<template>
  <div>
    <b-overlay
      :show="formShow"
      rounded="true"
      no-fade
      style="height:100vh!important"
      class="mb-5"
    >
      <b-card :aria-hidden="formShow ? 'true' : null">
        <b-row>
          <table class="table">
            <tr>
              <th
                scope="col"
                class="bg-primary text-white align-middle"
                style="font-size: 1.2em;"
              >
                EDIT REVIEW
              </th>
              <th
                scope="col"
                class="bg-primary text-white d-flex justify-content-end align-middle"
              >
                <b-button
                  variant="success"
                  v-show="$Can('view_individual_summary')"
                  class="animate__animated animate__fadeIn"
                  style="width: 17%; background-color:white;color:#003b49;margin-right:0.5rem"
                  @click="summaryPage()"
                >
                  Summary Explanation
                  <!-- <feather-icon style="vertical-align: unset;" icon="ColumnsIcon" /> -->
                </b-button>
                <b-button
                  variant="success-dark"
                  v-show="$Can('view_review_files_button')"
                  class="animate__animated animate__fadeIn"
                  style="width: 17%; background-color:white;color:#003b49;margin-right:0.5rem"
                  @click="openFilesModal()"
                >
                  Files
                </b-button>
                <b-button
                  variant="danger"
                  @click="sendMail()"
                  class="animate__animated animate__fadeIn"
                  v-show="$Can('send_review_email_button')"
                  :disabled="!editReviewData.emailAdress"
                  style="width: 17%; background-color:white;color:#003b49;margin-right:0.5rem"
                >
                  Send Email
                  <!-- <feather-icon style="vertical-align: unset;" icon="SendIcon" /> -->
                </b-button>

                <!-- <b-button
                variant="secondary"
                class="animate__animated animate__fadeIn"
                v-show="$Can('download_review_button')"
                style="width: 17%; background-color:white;;margin-right:0.5rem"
                @click="downloadReport()"
              >
                Download Report
                <feather-icon
                  style="vertical-align: unset;"
                  icon="DownloadIcon"
                />
              </b-button> -->

                <b-button
                  variant="secondary"
                  class="animate__animated animate__fadeIn"
                  v-show="$Can('download_empty_form_button')"
                  style="width: 17%; background-color:white;;margin-right:0.5rem"
                  @click="downloadEmptyForm()"
                >
                  Download Empty Form
                  <feather-icon
                    style="vertical-align: unset;"
                    icon="DownloadIcon"
                  />
                </b-button>
                <b-button
                  variant="secondary"
                  class="animate__animated animate__fadeIn"
                  v-show="$Can('download_review_report_button')"
                  style="width: 17%; background-color:white;color:#003b49;margin-right:0.5rem"
                  @click="downloadNewForm()"
                >
                  Download Report
                  <feather-icon
                    style="vertical-align: unset;"
                    icon="DownloadIcon"
                  />
                </b-button>
                <b-button
                  type="submit"
                  @click.prevent="formSubmitted"
                  v-if="editReviewData.status == 'A'"
                  variant="warning"
                  class="animate__animated animate__fadeIn"
                  style="width: 17%; background-color:white;color:#003b49;margin-right:0.5rem"
                >
                  Save
                </b-button>
                <b-button
                  type="submit"
                  @click.prevent="formSubmitted"
                  v-else
                  v-show="
                    currentUser == userData.name + ' ' + userData.surname &&
                      editReviewData.status == 'A'
                  "
                  variant="warning"
                  class="animate__animated animate__fadeIn"
                  style="width: 17%;  background-color:white;color:#003b49;margin-right:0.5rem"
                >
                  Save
                </b-button>

                <b-button
                  ref="completeButton"
                  variant="success"
                  class="float-right animate__animated animate__fadeIn"
                  v-if="userDataRole == 'supermanager'"
                  v-show="editReviewData.status == 'A'"
                  style="width: 17%; background-color:white;color:#003b49;margin-right:0.1rem;"
                  @click="completeReview()"
                >
                  Complete
                  <!-- <feather-icon icon="CheckIcon" /> -->
                </b-button>
                <b-button
                  ref="completeButton"
                  class="float-right animate__animated animate__fadeIn"
                  variant="success"
                  v-else
                  v-show="
                    $Can('complete_review_button') &&
                      editReviewData.status == 'A'
                  "
                  style="width: 17%;  background-color:white;color:#003b49;margin-right:0.1rem;"
                  @click="completeReview()"
                >
                  Complete
                  <!-- <feather-icon icon="CheckIcon" /> -->
                </b-button>
              </th>
            </tr>
          </table>
        </b-row>

        <!-- Breadcrumb Navigation -->
        <b-breadcrumb class="bg-transparent px-0 py-2 mb-3">
          <b-breadcrumb-item :to="{ name: 'review-list' }">
            <feather-icon icon="ListIcon" size="16" class="mr-1" />
            Review List
          </b-breadcrumb-item>
          <b-breadcrumb-item active>
            <feather-icon icon="EditIcon" size="16" class="mr-1" />
            {{ editReviewData.title || "Review" }}
          </b-breadcrumb-item>
        </b-breadcrumb>

        <validation-observer ref="reviewRules">
          <b-form>
            <!-- Follow-up review banner -->
            <b-alert
              v-if="editReviewData.review_type === 'followup' && editReviewData.original_review"
              show
              variant="info"
              class="mb-1"
            >
              <feather-icon icon="RefreshCwIcon" class="mr-50" />
              This is a <strong>{{ editReviewData.interval_months }}-Month Follow-up Review</strong> of
              <strong>{{ editReviewData.original_review.firstName }} {{ editReviewData.original_review.lastName }}</strong>'s
              review.
              <router-link :to="{ name: 'review-preview', params: { id: editReviewData.original_review.id } }">
                View original
              </router-link>
            </b-alert>
            <b-alert
              v-else-if="editReviewData.review_type === 'followup'"
              show
              variant="info"
              class="mb-1"
            >
              <feather-icon icon="RefreshCwIcon" class="mr-50" />
              This is a <strong>{{ editReviewData.interval_months }}-Month Follow-up Review</strong>.
            </b-alert>

            <b-row class="mt-1">
              <!-- Person Selection -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Reviewee" label-for="person">
                  <validation-provider
                    name="Reviewee"
                    #default="{ errors }"
                    rules="required"
                  >
                    <v-select
                      id="person"
                      v-model="selectedPerson"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="fullName"
                      :reduce="(val) => val"
                      :clearable="false"
                      :options="observers"
                      @option:selected="selectedPersonHandler"
                      :disabled="!$Can('edit_review')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- First Name -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group>
                  <label for="firstName">First Name</label>
                  <validation-provider
                    name="firstName"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-input
                      id="firstName"
                      type="text"
                      v-model="editReviewData.firstName"
                      disabled
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Last Surname -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Last Name" label-for="lastName">
                  <validation-provider
                    name="lastName"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-input
                      id="lastName"
                      type="text"
                      v-model="editReviewData.lastName"
                      disabled
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Email -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Email" label-for="email">
                  <validation-provider
                    name="Email"
                    #default="{ errors }"
                    rules="required|email"
                  >
                    <b-form-input
                      id="email"
                      type="text"
                      v-model="editReviewData.emailAdress"
                      disabled
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Event -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Questionnaire" label-for="event">
                  <validation-provider
                    name="event"
                    #default="{ errors }"
                    rules="required"
                  >
                    <v-select
                      id="event"
                      v-model="editReviewData.event"
                      :options="eventTypes"
                      :reduce="(val) => val"
                      :filterable="true"
                      label="title"
                      :disabled="true"
                      :clearable="false"
                      input-id="event"
                    >
                      <template #option="option">
                        <div
                          style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 300px;"
                          :title="option.title"
                        >
                          {{ option.title }}
                        </div>
                      </template>
                      <template #selected-option="option">
                        <div
                          style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px;"
                          :title="option.title"
                        >
                          {{ option.title }}
                        </div>
                      </template>
                      <template #no-options="{ search, searching, loading }">
                        {{
                          selectedPerson
                            ? "This is the no options slot "
                            : "Please select a Reviewee"
                        }}
                      </template>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Observer -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Reviewer" label-for="observer">
                  <validation-provider
                    name="observer"
                    #default="{ errors }"
                    rules="required"
                  >
                    <v-select
                      id="observer"
                      v-model="editReviewData.observer"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="fullName"
                      :reduce="(val) => val"
                      :clearable="false"
                      :options="observers"
                      @option:selected="
                        selectedObserver(editReviewData.observer)
                      "
                      :disabled="!$Can('edit_review')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Task Info Display (Read-only, from Questionnaire) -->
              <b-col
                cols="12"
                sm="6"
                md="4"
                xl="3"
                v-if="editReviewData.selectedTask"
              >
                <b-form-group label="Assigned Task" label-for="task-display">
                  <b-input-group>
                    <b-form-input
                      id="task-display"
                      :value="
                        editReviewData.selectedTask
                          ? editReviewData.selectedTask.title
                          : 'No task assigned'
                      "
                      readonly
                      style="background-color: #f8f9fa;"
                    />
                    <b-input-group-append>
                      <b-button variant="outline-secondary" disabled>
                        <feather-icon icon="LockIcon" size="14" />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-muted"
                    >Task is configured in the Questionnaire settings</small
                  >
                </b-form-group>
              </b-col>

              <!-- Review Date -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group>
                  <label for="surveyDate">Review Date</label>
                  <validation-provider
                    name="surveyDate"
                    #default="{ errors }"
                    rules="required"
                  >
                    <flat-pickr
                      id="surveyDate"
                      class="form-control"
                      :config="{ dateFormat: 'd/m/Y' }"
                      placeholder="DD/MM/YYYY"
                      v-model="editReviewData.surveyDate"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Working Time - Show only when task is selected -->
              <b-col
                cols="12"
                sm="6"
                md="4"
                xl="3"
                v-if="editReviewData.selectedTask"
              >
                <b-form-group>
                  <label>Working Time</label>
                  <div class="d-flex">
                    <b-button
                      :variant="
                        editReviewData.workingTime === 'am'
                          ? 'primary'
                          : 'outline-primary'
                      "
                      @click="setWorkingTime('am')"
                      class="mr-2"
                      style="border-radius: 50px; min-width: 60px;"
                    >
                      AM
                    </b-button>
                    <b-button
                      :variant="
                        editReviewData.workingTime === 'pm'
                          ? 'primary'
                          : 'outline-primary'
                      "
                      @click="setWorkingTime('pm')"
                      style="border-radius: 50px; min-width: 60px;"
                    >
                      PM
                    </b-button>
                  </div>
                </b-form-group>
              </b-col>

              <!-- Start Time - Show only when task is selected -->
              <b-col
                cols="12"
                sm="6"
                md="4"
                xl="3"
                v-if="editReviewData.selectedTask"
              >
                <b-form-group>
                  <label for="startTime">Start Time</label>
                  <flat-pickr
                    id="startTime"
                    v-model="editReviewData.startTime"
                    class="form-control"
                    :config="startTimeConfig"
                    @on-change="onStartTimeChange"
                  />
                </b-form-group>
              </b-col>

              <!-- End Time - Show only when task is selected -->
              <b-col
                cols="12"
                sm="6"
                md="4"
                xl="3"
                v-if="editReviewData.selectedTask"
              >
                <b-form-group>
                  <label for="endTime">End Time</label>
                  <flat-pickr
                    id="endTime"
                    v-model="editReviewData.endTime"
                    class="form-control"
                    :config="endTimeConfig"
                    @on-change="onEndTimeChange"
                  />
                </b-form-group>
              </b-col>

              <!-- General Comment -->

              <b-row class="mt-2">
                <!-- Total Score & Summary Explanation Section -->
                <b-col cols="12" xl="12" md="12" style="margin-bottom: 0.5rem;">
                  <div
                    class="current-range-card-slim d-flex align-items-center"
                  >
                    <!-- Sol taraf: Total Score -->
                    <div class="total-score-section">
                      <div class="score-label">Total Score</div>
                      <div class="score-value">{{ calculatedTotalScore }}</div>
                    </div>

                    <!-- Sağ taraf: Explanation -->
                    <div class="explanation-section flex-grow-1">
                      <div class="explanation-text">
                        {{ currentRangeExplanation }}
                      </div>
                    </div>
                  </div>
                </b-col>

                <b-col cols="12" xl="12" md="12" style="margin-bottom: 1rem;">
                  <!-- Enhanced Preview Table for Non-Active Reviews -->
                  <div v-if="editReviewData.status != 'A'">
                    <div
                      v-for="(group, groupIndex) in filteredOrderedGroups"
                      :key="group.id"
                      class="group-section"
                      :class="{ 'mt-4': groupIndex > 0 }"
                    >
                      <b-col
                        cols="12"
                        class="bodyRow"
                        style="padding: 0.2rem 0;"
                      >
                        <div
                          class="d-flex justify-content-between align-items-center mb-3"
                        >
                          <h4
                            class="group-title mb-0"
                            style="color: #003b49; font-weight: 600; border-bottom: 2px solid #003b49; padding-bottom: 0.5rem; flex-grow: 1;"
                          >
                            {{ group.groupName }}
                          </h4>
                          <div class="group-status-badges ml-3">
                            <b-badge
                              :variant="getGroupStatusVariant(group)"
                              class="group-status-badge mr-2"
                            >
                              {{ getGroupStatus(group) }}
                            </b-badge>
                            <div
                              class="group-score-info"
                              style="text-align: left; line-height: 1.3; font-family: monospace;"
                            >
                              <small class="text-muted d-block">
                                Group Score&nbsp;&nbsp;&nbsp;:
                                {{ calculateGroupScore(group) }}/{{
                                  calculateGroupMaxScore(group)
                                }}
                              </small>
                              <small
                                v-if="group.score"
                                class="text-muted d-block"
                              >
                                Passing Score : {{ group.score }}
                              </small>
                              <small v-else class="text-muted d-block">
                                Passing Score : N/A
                              </small>
                            </div>
                          </div>
                        </div>

                        <b-table-simple
                          fixed
                          striped
                          :outlined="true"
                          :responsive="true"
                          :bordered="true"
                          class="animate__animated animate__fadeIn mb-4"
                        >
                          <b-thead>
                            <b-tr>
                              <b-th style="width:50%">Questions</b-th>
                              <b-th class="text-center" style="width:25%"
                                >Answer</b-th
                              >
                              <b-th class="text-center" style="width:25%"
                                >Status</b-th
                              >
                            </b-tr>
                          </b-thead>
                          <b-tbody>
                            <b-tr
                              v-for="(question,
                              questionIndex) in getOrderedQuestions(group)"
                              :key="questionIndex"
                              :class="getQuestionRowClass(question, group)"
                            >
                              <b-th
                                class="text-left"
                                style="font-weight: normal;"
                              >
                                <div class="question-content">
                                  {{ question.title }}

                                  <!-- Max Score ve Passing Score soru başlığının altında -->
                                  <div
                                    v-if="question.status === 'A'"
                                    class="score-details mt-1 mb-1"
                                    style="font-size: 0.85rem; color: #6c757d;"
                                  >
                                    <span v-if="question.maxScore">
                                      ( Max Score: {{ question.maxScore }} )
                                    </span>
                                    <span
                                      v-if="
                                        question.passingScore !== null &&
                                          question.passingScore !== undefined
                                      "
                                    >
                                      ( Passing Score :
                                      {{ question.passingScore || 0 }} )
                                    </span>
                                  </div>

                                  <div class="question-badges mt-1">
                                    <b-badge
                                      v-if="isCompulsoryQuestion(question)"
                                      variant="warning"
                                      class="compulsory-badge mr-2"
                                    >
                                      Compulsory
                                    </b-badge>
                                  </div>
                                  <div v-if="question.subtitle" class="mt-1">
                                    <small
                                      class="text-muted"
                                      style="font-style: italic;"
                                    >
                                      {{ question.subtitle }}
                                    </small>
                                  </div>
                                </div>
                              </b-th>
                              <b-td
                                class="text-center"
                                :style="getAnswerStyle(question, group)"
                              >
                                <span class="answer-display">
                                  {{ getQuestionAnswerById(question.id) }}
                                </span>
                              </b-td>
                              <b-td class="text-center">
                                <div>
                                  <div
                                    v-if="
                                      getQuestionStatus(
                                        question,
                                        group
                                      ).includes('Failed')
                                    "
                                  >
                                    <small
                                      class="font-weight-bold px-2 py-1"
                                      style="font-style: italic; color: white; background-color: #d35400; border-radius: 4px; display: inline-block;"
                                    >
                                      {{ currentRangeExplanation || "FAILED" }}
                                    </small>
                                  </div>
                                  <b-badge
                                    v-else
                                    :variant="
                                      getQuestionStatusVariant(question, group)
                                    "
                                    class="question-status-badge"
                                  >
                                    {{ getQuestionStatus(question, group) }}
                                  </b-badge>
                                </div>
                              </b-td>
                            </b-tr>
                          </b-tbody>
                        </b-table-simple>
                      </b-col>
                    </div>
                  </div>

                  <!-- Original Editable Table for Active Reviews -->
                  <div v-else>
                    <div
                      v-for="(group, groupIndex) in filteredGroups"
                      :key="group.id"
                      class="group-section"
                      :class="{ 'mt-4': groupIndex > 0 }"
                    >
                      <b-col cols="12" xl="12" md="12" sm="12">
                        <h4
                          class="group-title mb-3"
                          style="color: #003b49; font-weight: 600; border-bottom: 2px solid #003b49; padding-bottom: 0.5rem;"
                        >
                          {{ group.groupName }}
                        </h4>
                        <b-table
                          hover
                          responsive
                          fixed
                          head-variant="dark"
                          :items="group.questions"
                          class="position-relative mb-4"
                          :fields="fields"
                          show-empty
                          empty-text="No questions found"
                        >
                          <template #cell(questions)="data">
                            <div>
                              <div class="question-content">
                                <span>{{ data.item.title }}</span>
                                <small
                                  v-if="
                                    data.item.status === 'A' &&
                                      data.item.maxScore
                                  "
                                  class="text-muted"
                                >
                                  ( Max Score: {{ data.item.maxScore }} )
                                </small>
                                <small
                                  v-if="
                                    data.item.status === 'A' &&
                                      data.item.passingScore !== null &&
                                      data.item.passingScore !== undefined
                                  "
                                  class="text-muted"
                                >
                                  ( Passing Score :
                                  {{ data.item.passingScore || 0 }} )
                                </small>
                              </div>
                              <small
                                v-if="data.item.subtitle"
                                class="d-block text-muted mt-1"
                                style="font-style: italic;"
                              >
                                {{ data.item.subtitle }}
                              </small>
                            </div>
                          </template>

                          <template #cell(answer)="data">
                            <validation-provider
                              :name="data.item.title"
                              #default="{ errors }"
                            >
                              <!-- status A Answer type -->
                              <v-select
                                v-if="
                                  data.item.status === 'A' &&
                                    editReviewData.status == 'A'
                                "
                                :id="data.item.title"
                                :options="generateScoreRange(data.item)"
                                :reduce="(val) => val"
                                :filterable="false"
                                :clearable="false"
                                v-model="data.item.commentAnswer"
                                :input-id="data.item.title"
                                @input="onAnswerChange"
                                :disabled="!editReviewData.status == 'A'"
                              />
                              <p
                                v-else-if="
                                  data.item.status === 'A' &&
                                    editReviewData.status != 'A'
                                "
                              >
                                {{ data.item.commentAnswer }}
                              </p>
                              <!-- status B Comment type -->
                              <span>
                                <b-form-textarea
                                  v-if="
                                    data.item.status != 'A' &&
                                      editReviewData.status == 'A'
                                  "
                                  :id="data.item.title"
                                  placeholder="Comment here"
                                  rows="2"
                                  debounce="500"
                                  no-resize
                                  v-model="data.item.commentAnswer"
                                  @input="onAnswerChange"
                                  style="width:100%"
                                  :disabled="!editReviewData.status == 'A'"
                                ></b-form-textarea>
                                <p
                                  v-else-if="
                                    data.item.status != 'A' &&
                                      editReviewData.status != 'A'
                                  "
                                >
                                  {{ data.item.commentAnswer }}
                                </p>

                                <small class="text-danger">{{
                                  errors[0]
                                }}</small>
                              </span>
                            </validation-provider>
                          </template>
                        </b-table>
                      </b-col>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-row>
          </b-form>
        </validation-observer>

        <b-row>
          <b-col cols="12" xl="12">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h4
                class="group-title mb-0"
                style="color: #003b49; font-weight: 600; border-bottom: 2px solid #003b49; padding-bottom: 0.5rem; flex-grow: 1;"
              >
                General Comment
              </h4>
            </div>
          </b-col>
          <b-col cols="12" xl="12">
            <b-form-textarea
              id="generalComment"
              :disabled="!$Can('edit_review') || editReviewData.status != 'A'"
              v-model="computedGeneralComment"
              placeholder="REVIEWE'S NOTES/RECOMMENDATIONS"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-col>
        </b-row>

        <!-- Follow-up Reviews Section -->
        <b-row v-if="pendingFollowUps.length || promotedFollowUps.length" class="mt-3">
          <b-col cols="12">
            <h5 class="mb-2">Follow-up Reviews</h5>
            <div v-if="pendingFollowUps.length" class="mb-2">
              <h6 class="text-muted">Pending</h6>
              <b-list-group>
                <b-list-group-item
                  v-for="fu in pendingFollowUps"
                  :key="fu.id"
                  class="d-flex justify-content-between align-items-center"
                >
                  <span>
                    {{ fu.interval_months }}-Month Follow-up &mdash; Scheduled
                    {{ formatUkDate(fu.scheduled_for) }}
                  </span>
                  <b-button
                    size="sm"
                    variant="primary"
                    :disabled="promotingId === fu.id"
                    @click="openPromoteModal(fu)"
                  >
                    <b-spinner v-if="promotingId === fu.id" small class="mr-50" />
                    Schedule Review
                  </b-button>
                </b-list-group-item>
              </b-list-group>
            </div>
            <div v-if="promotedFollowUps.length">
              <h6 class="text-muted">Activated Follow-ups</h6>
              <b-list-group>
                <b-list-group-item
                  v-for="fu in promotedFollowUps"
                  :key="fu.id"
                  class="d-flex justify-content-between align-items-center"
                >
                  <span>
                    {{ fu.interval_months }}-Month Follow-up
                    <small v-if="fu.surveyDate" class="text-muted ml-1">&mdash; {{ formatUkDate(fu.surveyDate) }}</small>
                    <b-badge v-if="fu.status === 'C'" variant="success" class="ml-1" pill>Completed</b-badge>
                    <b-badge v-else variant="warning" class="ml-1" pill>In Progress</b-badge>
                  </span>
                  <b-button
                    size="sm"
                    :variant="fu.status === 'C' ? 'outline-secondary' : 'outline-primary'"
                    :to="fu.status === 'C'
                      ? { name: 'review-preview', params: { id: fu.id } }
                      : { name: 'review-edit', params: { id: fu.id } }"
                    tag="router-link"
                  >
                    {{ fu.status === 'C' ? 'View Review' : 'Edit Review' }}
                  </b-button>
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-col>
        </b-row>
      </b-card>

      <b-card :show="formShow" v-if="timeLines.length > 0">
        <app-timeline class="mt-2">
          <app-timeline-item
            v-for="item in timeLines"
            :key="item.id"
            :variant="varyant(item.status)"
          >
            <div
              class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
            >
              <h6>{{ item.title }}</h6>
              <small class="text-muted">{{ item.created_at }}</small>
            </div>
            <p
              v-if="item.surveyId != 0"
              style="cursor: pointer"
              @click="reviewClick(item.surveyId)"
            >
              {{ " Quality Review Id : #" + item.surveyId }}
            </p>
          </app-timeline-item>
        </app-timeline>
      </b-card>

      <br /><br /><br />

      <template #overlay v-if="download || mailsend">
        <div class="text-center">
          <b-icon icon="stopwatch" font-scale="3" animation="cylon"> </b-icon>
          <p v-if="download" id="cancel-label">
            <feather-icon icon="DownloadIcon" /> Report creating please wait...
          </p>
          <p v-if="mailsend" id="cancel-label">
            <feather-icon icon="DownloadIcon" /> Mail sending please wait...
          </p>
        </div>
      </template>
    </b-overlay>

    <!-- Promote Follow-up Modal -->
    <b-modal
      id="promote-modal"
      v-model="showPromoteModal"
      title="Start Follow-up Review"
      size="md"
      @ok.prevent="confirmPromote"
      ok-title="Schedule Review"
      cancel-title="Cancel"
    >
      <b-form-group label="Review Date" label-for="promote-date">
        <flat-pickr
          id="promote-date"
          v-model="promoteForm.reviewDate"
          :config="promoteDateConfig"
          class="form-control"
          placeholder="DD/MM/YYYY"
        />
      </b-form-group>

      <b-form-group label="Working Time">
        <div class="d-flex">
          <b-button
            size="sm"
            :variant="promoteForm.workingTime === 'am' ? 'primary' : 'outline-secondary'"
            class="mr-1"
            @click="promoteSetWorkingTime('am')"
          >AM</b-button>
          <b-button
            size="sm"
            :variant="promoteForm.workingTime === 'pm' ? 'primary' : 'outline-secondary'"
            @click="promoteSetWorkingTime('pm')"
          >PM</b-button>
        </div>
      </b-form-group>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Start Time" label-for="promote-start-time">
            <flat-pickr
              id="promote-start-time"
              v-model="promoteForm.startTime"
              :config="promoteStartTimeConfig"
              class="form-control"
              placeholder="HH:MM"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="End Time" label-for="promote-end-time">
            <flat-pickr
              id="promote-end-time"
              v-model="promoteForm.endTime"
              :config="promoteEndTimeConfig"
              class="form-control"
              placeholder="HH:MM"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

    <!-- Files Modal (View Only) -->
    <b-modal
      id="files-modal"
      v-model="showFilesModal"
      title="Review Files"
      size="lg"
      hide-footer
    >
      <div>
        <h6>Questionnaire Files</h6>
        <div v-if="loadingFiles" class="text-center">
          <b-spinner class="mr-2"></b-spinner>
          Loading files...
        </div>
        <div v-else-if="questionnaireFiles.length === 0" class="text-muted">
          No files available for this questionnaire.
        </div>
        <b-table
          v-else
          :items="questionnaireFiles"
          :fields="fileTableFields"
          responsive
          small
          striped
          hover
        >
          <template #cell(name)="data">
            <a :href="data.item.url" target="_blank" class="text-primary">
              {{ data.item.original_name }}
            </a>
          </template>
          <template #cell(size)="data">
            {{ formatFileSize(data.item.size) }}
          </template>
          <template #cell(created_at)="data">
            {{ formatDate(data.item.created_at) }}
          </template>
        </b-table>
      </div>

      <div class="mt-3 text-right">
        <b-button variant="secondary" @click="showFilesModal = false">
          Close
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BCol,
  BRow,
  BTab,
  BTabs,
  BCard,
  BAlert,
  BIcon,
  BLink,
  VBModal,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BBadge,
} from "bootstrap-vue";
import { ref, onUnmounted } from "@vue/composition-api";

import store from "@/store";
import reviewStoreModule from "./reviewStoreModule";
import ImageCropper from "@core/components/image-cropper/ImageCropper.vue";
import { required, alphaNum, email } from "@validations";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import Cleave from "vue-cleave-component";
import "cleave.js/dist/addons/cleave-phone.us";
import router from "@/router";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import _ from "lodash";
import axiosIns from "@/libs/axios";
import { t } from "@/@core/libs/i18n/utils";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "animate.css";

import moment from "moment";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    BRow,
    BCol,
    BIcon,
    AppTimeline,
    AppTimelineItem,
    vSelect,
    Cleave,
    ToastificationContent,
    ImageCropper,
    FeatherIcon,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BBadge,
  },

  directives: {
    Ripple,
    "b-modal": VBModal,
  },

  setup() {
    const SETTINGS_APP_STORE_MODULE_NAME = "review";
    // Register module
    if (!store.hasModule(SETTINGS_APP_STORE_MODULE_NAME))
      store.registerModule(SETTINGS_APP_STORE_MODULE_NAME, reviewStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(SETTINGS_APP_STORE_MODULE_NAME))
        store.unregisterModule(SETTINGS_APP_STORE_MODULE_NAME);
    });
  },

  data: function() {
    var editReviewData = {
      surveyDate: null,
      firstName: null,
      lastName: null,
      emailAdress: null,
      observer: null,
      status: null,
      currentUser: null,
      event: {
        groups: [],
      },
      generalComment: null,
      questionAnswer: [],
      //groups: [],
      // totalScore and explanation are now computed properties
      selectedTask: null,
      startTime: null,
      endTime: null,
      workingTime: "am",
    };

    const statusOptions = [
      { label: "Active", value: "active" },
      { label: "Passive", value: "passive" },
    ];

    return {
      timeLines: [],
      userDataRole: JSON.parse(localStorage.getItem("userData")).role,
      userData: JSON.parse(localStorage.getItem("userData")),
      currentUser: JSON.parse(localStorage.getItem("userData")),
      editReviewData: editReviewData,
      baseURL: store.state.app.baseURL,
      required,
      alphaNum,
      observers: [],
      selectedPerson: null,
      email,
      waitCompleteBtn: false,
      // Task dropdown data removed - tasks now configured in questionnaire
      startTimeConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        minuteIncrement: 5,
        defaultHour: 8,
        defaultMinute: 0,
      },
      endTimeConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        minuteIncrement: 5,
        defaultHour: 9,
        defaultMinute: 0,
      },
      formShow: false,
      groups: [],
      download: false,
      mailsend: false,
      ans: null,
      pendingFollowUps: [],
      promotedFollowUps: [],
      promotingId: null,
      // Promote Follow-up Modal
      showPromoteModal: false,
      promotingFu: null,
      promoteForm: {
        reviewDate: null,
        startTime: null,
        endTime: null,
        workingTime: 'am',
      },
      promoteDateConfig: {
        dateFormat: 'd/m/Y',
        allowInput: true,
      },
      promoteStartTimeConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        time_24hr: true,
        minuteIncrement: 5,
        defaultHour: 8,
        defaultMinute: 0,
      },
      promoteEndTimeConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        time_24hr: true,
        minuteIncrement: 5,
        defaultHour: 9,
        defaultMinute: 0,
      },
      storedExplanation: null,
      summaryData: null,
      filteredQuestions: [],
      eventTypes: [],
      // Add a reactive trigger for computed properties
      forceRecompute: 0,
      fields: [
        {
          key: "questions",
          label: "questions",
          thStyle: { width: "70%" },
        },
        {
          key: "answer",
          label: "answer",
          thStyle: { width: "30%" },
          thClass: "text-center",
          tdClass: "text-center ",
        },
      ],
      // Files Modal Data
      showFilesModal: false,
      loadingFiles: false,
      questionnaireFiles: [],
      fileTableFields: [
        { key: "name", label: "File Name", sortable: true },
        { key: "size", label: "Size", sortable: true },
        { key: "created_at", label: "Upload Date", sortable: true },
      ],
    };
  },
  computed: {
    filteredGroups() {
      if (!this.editReviewData?.event?.groups) return [];
      const groups = this.editReviewData.event.groups;
      if (this.editReviewData.review_type === 'followup') {
        return groups.filter(g => g.follow_up_months === this.editReviewData.interval_months);
      }
      return groups.filter(g => g.follow_up_months == null);
    },
    filteredOrderedGroups() {
      return [...this.filteredGroups].sort((a, b) => {
        if (a.order && b.order) return a.order - b.order;
        return 0;
      });
    },
    orderedGroups() {
      if (
        !this.editReviewData ||
        !this.editReviewData.event ||
        !this.editReviewData.event.groups
      ) {
        return [];
      }
      // Sort groups by order if available, otherwise maintain original order
      return [...this.editReviewData.event.groups].sort((a, b) => {
        if (a.order && b.order) {
          return a.order - b.order;
        }
        return 0;
      });
    },

    // Calculate total score dynamically when answers change
    calculatedTotalScore() {
      // Force reactivity trigger
      this.forceRecompute;

      if (!this.editReviewData.event?.groups) {
        return 0;
      }

      let totalScore = 0;

      // Directly calculate from groups data instead of questionAnswer array
      this.editReviewData.event.groups.forEach((group) => {
        group.questions.forEach((question) => {
          if (
            question &&
            question.status === "A" &&
            question.commentAnswer !== "Not Observed" &&
            question.commentAnswer !== undefined &&
            question.commentAnswer !== null &&
            question.commentAnswer !== "" &&
            !isNaN(question.commentAnswer)
          ) {
            totalScore += Number(question.commentAnswer);
          }
        });
      });

      return totalScore;
    },

    // Get explanation from API for current review
    calculatedExplanation() {
      if (!this.editReviewData.id) {
        return null;
      }

      // We'll need to fetch this from API or store it separately
      // For now, return null and handle it via separate API call if needed
      return this.storedExplanation || null;
    },

    // Parse summary ranges from stored explanation
    summaryRanges() {
      // Force reactivity trigger
      this.forceRecompute;

      // If we have the full summary data with ranges and explanations
      if (
        this.summaryData &&
        this.summaryData.ranges &&
        this.summaryData.explanations
      ) {
        const ranges = this.summaryData.ranges;
        const explanations = this.summaryData.explanations;

        return explanations.map((explanation, index) => {
          const minScore = ranges[index] || 0;
          const maxScore = ranges[index + 1] ? ranges[index + 1] - 1 : "+";

          return {
            minScore: minScore,
            maxScore: maxScore,
            rangeText:
              maxScore === "+" ? `${minScore}+` : `${minScore}-${maxScore}`,
            explanation: explanation.title.replace(/#totalScore#/g, "[Score]"),
          };
        });
      }

      // If storedExplanation is an array (from backend response.data.title)
      if (Array.isArray(this.storedExplanation)) {
        return this.storedExplanation.map((item, index) => {
          // Each item should have range and title properties
          return {
            minScore: item.range || 0,
            maxScore:
              index < this.storedExplanation.length - 1
                ? this.storedExplanation[index + 1].range - 1
                : "+",
            rangeText:
              index < this.storedExplanation.length - 1
                ? `${item.range}-${this.storedExplanation[index + 1].range - 1}`
                : `${item.range}+`,
            explanation: item.title.replace(/#totalScore#/g, "[Score]"),
          };
        });
      }

      // If we only have stored explanation without ranges as string, create a single range
      if (
        this.storedExplanation &&
        typeof this.storedExplanation === "string"
      ) {
        return [
          {
            minScore: 0,
            maxScore: "+",
            rangeText: "All Scores",
            explanation: this.storedExplanation.replace(
              /#totalScore#/g,
              "[Score]"
            ),
          },
        ];
      }

      return [];
    },

    // Check if there are any failed questions
    hasFailedQuestions() {
      // Force reactivity trigger
      this.forceRecompute;

      if (!this.editReviewData?.event?.groups) {
        return false;
      }

      return this.editReviewData.event.groups.some((group) =>
        group.questions.some((question) => {
          if (question.status !== "A") return false;

          const answer = this.getQuestionAnswerById(question.id);
          if (
            answer === "Not Observed" ||
            answer === "No answer" ||
            answer === null ||
            answer === undefined
          ) {
            return false;
          }

          const score = parseFloat(answer);
          const passingScore = parseFloat(question.passingScore || 0);

          return (
            !isNaN(score) &&
            !isNaN(passingScore) &&
            passingScore > 0 &&
            score < passingScore
          );
        })
      );
    },

    // Check if any group status reflects a failure
    anyGroupFailed() {
      // Force reactivity trigger
      this.forceRecompute;

      const groups =
        this.editReviewData &&
        this.editReviewData.event &&
        this.editReviewData.event.groups
          ? this.editReviewData.event.groups
          : [];

      const failedStatus = this.getFailedStatus;

      return groups.some((group) => {
        const status = this.getGroupStatus(group);
        return (
          typeof status === "string" &&
          (status.includes("Failed") ||
            (failedStatus && status.includes(failedStatus)))
        );
      });
    },

    // Get the explanation for current score range
    currentRangeExplanation() {
      // Force reactivity trigger
      this.forceRecompute;

      let explanation = null;

      // If any group failed (or there are failed questions), use the lowest range explanation
      if ((this.anyGroupFailed || this.hasFailedQuestions) && this.summaryRanges.length > 0) {
        explanation = this.summaryRanges[0].explanation.replace(
          /\[Score\]/g,
          "#totalScore#"
        );
      } else {
        const currentRange = this.summaryRanges.find((range) =>
          this.isCurrentRange(range)
        );
        explanation = currentRange
          ? currentRange.explanation.replace(/\[Score\]/g, "#totalScore#")
          : null;
      }

      // Replace #totalScore# with actual calculated score
      if (explanation && explanation.includes("#totalScore#")) {
        explanation = explanation.replace(
          /#totalScore#/g,
          this.calculatedTotalScore
        );
      }

      return explanation;
    },

    getFailedStatus() {
      if (!this.summaryRanges || this.summaryRanges.length === 0) return "Failed";
      try {
        const raw = this.summaryRanges[0].explanation;
        if (!raw || typeof raw !== "string") return "Failed";
        const cleaned = raw.replace("- [Score]", "").trim();
        return cleaned || "Failed";
      } catch (e) {
        return "Failed";
      }
    },


    // Dynamic computed property to update #totalScore# placeholders automatically
    computedGeneralComment: {
      get() {
        // Force reactivity trigger
        this.forceRecompute;

        let comment = this.editReviewData.generalComment || "";

        // If status is 'C' (Completed), replace #totalScore# with actual score
        // If status is 'A' (Active), keep #totalScore# as is
        if (
          this.editReviewData.status === "C" &&
          this.calculatedTotalScore !== null &&
          comment.includes("#totalScore#")
        ) {
          return comment.replace(/#totalScore#/g, this.calculatedTotalScore);
        }

        // For status 'A' or other statuses, return comment as is (with #totalScore# placeholders)
        return comment;
      },
      set(value) {
        // When user edits, try to preserve placeholders by converting specific patterns back
        if (this.calculatedTotalScore !== null) {
          // Replace "Summary [number] Explanation" with "Summary #totalScore# Explanation"
          // This pattern specifically targets our summary explanation format
          const summaryPattern = new RegExp(
            `(Summary\\s+)${this.calculatedTotalScore}(\\s+Explanation)`,
            "gi"
          );
          value = value.replace(summaryPattern, "$1#totalScore#$2");
        }

        this.editReviewData.generalComment = value;
      },
    },
  },
  watch: {
    '$route.params.id'(newId, oldId) {
      if (newId !== oldId) {
        this.getReviewData(newId);
        this.timelineReviewList(newId);
      }
    },
  },
  mounted() {
    this.getReviewData(this.$route.params.id);
    this.timelineReviewList(this.$route.params.id);
    this.getObservers();
    this.updateTimeConfigs("am");
  },
  methods: {
    convertDateToDisplay(date) {
      if (!date) return null;
      // Try to parse the date from backend (might be in MM-DD-YYYY format)
      const parsedDate = moment(
        String(date),
        ["MM-DD-YYYY", "M-D-YYYY", "YYYY-MM-DD"],
        true
      );
      if (parsedDate.isValid()) {
        // Return in DD/MM/YYYY format for flatpickr
        return parsedDate.format("DD/MM/YYYY");
      }
      // If parsing fails, return as is
      return date;
    },

    convertDateToBackend(date) {
      if (!date) return null;
      // Parse date from DD/MM/YYYY format and convert to MM-DD-YYYY for backend
      const parsedDate = moment(String(date), "DD/MM/YYYY", true);
      if (parsedDate.isValid()) {
        return parsedDate.format("MM-DD-YYYY");
      }
      // If parsing fails, return as is
      return date;
    },

    takeAQuestionAnswer(ans) {
      this.ans = ans;
    },

    onAnswerChange() {
      // Sync questionAnswer array with current question values
      this.editReviewData.event.groups.forEach((group) => {
        group.questions.forEach((question) => {
          // Find the corresponding questionAnswer entry
          const answerEntry = this.editReviewData.questionAnswer.find(
            (qa) => qa.questionId === question.id
          );
          if (answerEntry) {
            answerEntry.commentAnswer = question.commentAnswer;
          }
        });
      });

      // Trigger reactivity for total score and range calculations
      this.forceRecompute++;
    },

    dateFormat(val) {
      return moment(String(val)).format("DD-MM-YYYY HH:mm");
    },

    varicon(val) {
      if (val == "A") {
        return "AwardIcon";
      } else if (val == "B") {
        return "InfoIcon";
      } else if (val == "C") {
        return "ClockIcon";
      } else if (val == "D") {
        return "InfoIcon";
      } else if (val == "E" || val == "I" || val == "J") {
        return "UserIcon";
      } else if (val == "PA") {
        return "GridIcon";
      } else if (val == "P") {
        return "GridIcon";
      } else if (val == "G") {
        return "DollarSignIcon";
      } else if (val == "H") {
        return "EyeOffIcon";
      } else {
        return "success";
      }
    },

    varyant(val) {
      if (val == "A") {
        return "info";
      } else if (val == "B") {
        return "secondary";
      } else if (val == "C") {
        return "warning";
      } else if (val == "D") {
        return "danger";
      } else if (val == "E") {
        return "success";
      } else if (val == "I") {
        return "success";
      } else if (val == "J") {
        return "danger";
      } else if (val == "PA") {
        return "info";
      } else if (val == "P") {
        return "danger";
      } else if (val == "G") {
        return "success";
      } else if (val == "H") {
        return "danger";
      } else {
        return "success";
      }
    },

    timelineReviewList(val) {
      this.formShow = true;

      if (router.currentRoute.params.id) {
        store
          .dispatch("review/timelineReviewList", val)
          .then((response) => {
            this.timeLines = response.data;
            this.formShow = false;
          })
          .catch((error) => {});
      } else {
        this.formShow = false;
      }
    },

    summaryPage() {
      router.push({
        name: "summary-explanation",
        params: { id: this.$route.params.id },
      });
    },
    selectedGroupValue(val) {
      // Update the questionAnswer array
      this.editReviewData.questionAnswer.forEach((question) => {
        if (question.questionId == Number(val.id)) {
          question.commentAnswer = val.commentAnswer;
        }
      });

      // Also ensure the question object itself is updated
      this.editReviewData.event.groups.forEach((group) => {
        group.questions.forEach((question) => {
          if (question.id == Number(val.id)) {
            question.commentAnswer = val.commentAnswer;
          }
        });
      });

      // Trigger reactivity for total score calculation
      this.forceRecompute++;
    },
    getObservers() {
      this.observers = [];
      axiosIns
        .get(`existingObservers`)
        .then((res) => {
          this.observers = res.data.data;
          // this.reviewData.observer = this.userData.fullName;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectedObserver(selectedObserver) {
      this.editReviewData.observer = selectedObserver.fullName;
    },
    // Task methods removed - tasks now configured in questionnaire
    setWorkingTime(timeType) {
      this.editReviewData.workingTime = timeType;
      this.updateTimeConfigs(timeType);
    },
    updateTimeConfigs(timeType) {
      if (timeType === "am") {
        // AM: Sabah saatleri (00:00 - 12:00)
        this.startTimeConfig = {
          ...this.startTimeConfig,
          defaultHour: 8,
          defaultMinute: 0,
        };
        this.endTimeConfig = {
          ...this.endTimeConfig,
          defaultHour: 9, // AM'de 9 olmalı, 12 değil
          defaultMinute: 0,
        };

        // AM'e geçerken saatleri sabah saatlerine ayarla
        if (
          !this.editReviewData.startTime ||
          this.editReviewData.startTime > "12:00"
        ) {
          this.editReviewData.startTime = "08:00";
        }
        if (
          !this.editReviewData.endTime ||
          this.editReviewData.endTime > "12:00"
        ) {
          this.editReviewData.endTime = "09:00";
        }
      } else {
        // PM: Akşam saatleri (13:00 - 23:55)
        this.startTimeConfig = {
          ...this.startTimeConfig,
          defaultHour: 13,
          defaultMinute: 0,
        };
        this.endTimeConfig = {
          ...this.endTimeConfig,
          defaultHour: 17,
          defaultMinute: 0,
        };

        // PM'e geçerken saatleri öğleden sonra saatlerine ayarla
        if (
          !this.editReviewData.startTime ||
          this.editReviewData.startTime < "13:00"
        ) {
          this.editReviewData.startTime = "13:00";
        }
        if (
          !this.editReviewData.endTime ||
          this.editReviewData.endTime < "13:00"
        ) {
          this.editReviewData.endTime = "17:00";
        }
      }

      // Force flatpickr to re-read the updated config
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    onStartTimeChange() {
      // Start time değiştiğinde end time'ı kontrol et
      if (this.editReviewData.startTime && this.editReviewData.endTime) {
        if (this.editReviewData.startTime >= this.editReviewData.endTime) {
          // Start time end time'dan büyük veya eşitse, end time'ı otomatik ayarla
          const startHour = parseInt(
            this.editReviewData.startTime.split(":")[0]
          );
          const startMinute = parseInt(
            this.editReviewData.startTime.split(":")[1]
          );

          let newEndHour = startHour;
          let newEndMinute = startMinute + 5; // 5 dakika ekle

          if (newEndMinute >= 60) {
            newEndHour += 1;
            newEndMinute = 0;
          }

          // AM/PM sınırlarına göre maksimum kontrolü
          const maxHour = this.editReviewData.workingTime === "am" ? 11 : 23;
          const maxMinute = 55;

          if (
            newEndHour > maxHour ||
            (newEndHour === maxHour && newEndMinute > maxMinute)
          ) {
            newEndHour = maxHour;
            newEndMinute = maxMinute;
          }

          this.editReviewData.endTime = `${newEndHour
            .toString()
            .padStart(2, "0")}:${newEndMinute.toString().padStart(2, "0")}`;
        }
      }
    },
    onEndTimeChange() {
      // End time değiştiğinde start time'ı kontrol et
      if (this.editReviewData.startTime && this.editReviewData.endTime) {
        if (this.editReviewData.endTime <= this.editReviewData.startTime) {
          // End time start time'dan küçük veya eşitse, end time'ı otomatik ayarla (yukarı çıkar)
          const startHour = parseInt(
            this.editReviewData.startTime.split(":")[0]
          );
          const startMinute = parseInt(
            this.editReviewData.startTime.split(":")[1]
          );

          let newEndHour = startHour;
          let newEndMinute = startMinute + 5; // 5 dakika ekle

          if (newEndMinute >= 60) {
            newEndHour += 1;
            newEndMinute = 0;
          }

          // AM/PM sınırlarına göre maksimum kontrolü
          const maxHour = this.editReviewData.workingTime === "am" ? 11 : 23;
          const maxMinute = 55;

          if (
            newEndHour > maxHour ||
            (newEndHour === maxHour && newEndMinute > maxMinute)
          ) {
            newEndHour = maxHour;
            newEndMinute = maxMinute;
          }

          this.editReviewData.endTime = `${newEndHour
            .toString()
            .padStart(2, "0")}:${newEndMinute.toString().padStart(2, "0")}`;
        }
      }
    },
    formatTime(timeString) {
      if (!timeString) return null;
      // Convert HH:MM:SS to HH:MM
      return timeString.substring(0, 5);
    },
    selectedPersonHandler(person) {
      if (person) {
        this.editReviewData.firstName = person.name;
        this.editReviewData.lastName = person.surname;
        this.editReviewData.emailAdress = person.email;

        // this.editReviewData.event = null;
        // this.groups = [];
        // this.eventTypes = [];
        // this.allQuestionnaires.forEach((q) => {
        //   this.eventTypes.push(q);
        // });
      }
    },
    completeReview() {
      this.formShow = true;
      this.$refs.reviewRules.validate().then((success) => {
        if (success) {
          let completeQualityReview = {
            status: "C",
            id: this.editReviewData.id,
          };
          this.$swal({
            title: "Are you sure?",
            text:
              "If you approve, you will not be able to update this quality review again.",
            icon: "warning",
            showCancelButton: true,
            // showDenyButton: true,
            confirmButtonText: "Yes, confirm it!",
            cancelButtonText: "Cancel",
            // denyButtonText: `Create as new questionnaire`,
            customClass: {
              confirmButton: "btn btn-success",
              cancelButton: "btn btn-danger",
              // denyButton: 'btn btn-primary',
            },
            // reverseButtons: true,
          }).then((result) => {
            if (result.isConfirmed) {
              store
                .dispatch("review/completeReview", completeQualityReview)
                .then((res) => {
                  this.toastCompleteMessage("Review");
                  this.getReviewData(this.$route.params.id);
                  this.formShow = false;
                })
                .catch((error) => {
                  console.log(error);
                  this.formShow = false;
                });
            } else {
              this.formShow = false;
            }
          });
        } else {
          this.formShow = false;
        }
      });
    },
    onHidden() {
      this.$refs.completeButton.focus();
    },

    generateScoreRange(item) {
      const options = ["Not Observed"];

      if (item.maxScore) {
        for (let i = item.maxScore; i >= 0; i--) {
          options.push(i.toString());
        }
      }

      return options;
    },

    sendMail() {
      this.formShow = true;
      this.mailsend = true;
      let reportArray = [];
      let downQuestions = [];
      let emptyGroupQuestion = [];

      let groupAnswers = _(this.editReviewData.questionAnswer)
        .groupBy("questionId")
        .map((question, id, index) => {
          return question[0];
        })
        .value();

      this.editReviewData.event.groups.forEach((element, index) => {
        //filter and group by all questions
        downQuestions = _.filter(groupAnswers, {
          groupId: element.id,
          // status: 'A',
        });

        //order comment answer
        downQuestions = _.orderBy(downQuestions, ["status"], ["asc"]);

        //Questions count / for domain score
        let questionsCount = _.filter(groupAnswers, {
          groupId: element.id,
          status: "A",
        });

        questionsCount = _.filter(questionsCount, function(o) {
          return o.commentAnswer != "Not Observed";
        });

        let count = 0;
        let percentageScores = []; // Her sorunun yüzdelik skorunu tutacak array

        if (downQuestions.length > 0) {
          downQuestions.forEach((question) => {
            this.editReviewData.questionAnswer.forEach((answer) => {
              if (question.questionId === answer.questionId) {
                if (question.status == "A") {
                  // Skor hesaplama
                  question.itemScore =
                    answer.commentAnswer != "Not Observed"
                      ? Number(answer.commentAnswer)
                      : 0;

                  // Yüzdelik hesaplama
                  if (question.itemScore !== 0) {
                    // "Not Observed" değilse
                    const percentage =
                      (question.itemScore / question.maxScore) * 100;
                    percentageScores.push(percentage);
                  }
                }
              }
            });
          });

          // Domain score'u yüzdelerin ortalaması olarak hesapla
          if (percentageScores.length > 0) {
            const averagePercentage =
              percentageScores.reduce((a, b) => a + b, 0) /
              percentageScores.length;
            downQuestions[0].domainScore = averagePercentage.toFixed(2);
          }
        }

        if (element.questions.length == 0) {
          emptyGroupQuestion.push(index);
        }

        reportArray.push(downQuestions);
      });

      // if (reportArray.length > 0) {
      //   reportArray = _.reject(reportArray, _.isEmpty);
      // }

      if (reportArray.length > 0) {
        reportArray = _.reject(reportArray, _.isEmpty);
      }
      if (emptyGroupQuestion.length > 0) {
        for (var i = emptyGroupQuestion.length - 1; i >= 0; i--)
          this.editReviewData.event.groups.splice(emptyGroupQuestion[i], 1);
      }

      store
        .dispatch("review/mailSend", {
          data: reportArray,
          groups: this.editReviewData.event.groups,
          info: {
            id: this.editReviewData.id,
            eventName: this.editReviewData.event.title,
            surveyDate: this.editReviewData.surveyDate,
            firstName: this.editReviewData.firstName,
            lastName: this.editReviewData.lastName,
            emailAdress: this.editReviewData.emailAdress,
            observer: this.editReviewData.observer,
            generalComment: this.editReviewData.generalComment,
          },
        })
        .then((response) => {
          if (response.status == 200) {
            this.mailsend = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Success",
                text: "✔️ Email successfully sent!",
                icon: "MailIcon",
                variant: "success",
              },
            });
            this.formShow = false;
          } else {
            this.mailsend = false;
            this.formShow = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Error",
                text: "An error occurred while sending the email.",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((error) => {
          this.mailsend = false;
          this.formShow = false;

          let errorMessage = "An error occurred while sending the email.";
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            errorMessage = error.response.data.message;
          }

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Email Sending Error",
              text: errorMessage,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    downloadReport() {
      this.formShow = true;
      this.download = true;
      let reportArray = [];
      let downQuestions = [];
      let emptyGroupQuestion = [];

      let groupAnswers = _(this.editReviewData.questionAnswer)
        .groupBy("questionId")
        .map((question, id, index) => {
          return question[0];
        })
        .value();

      this.editReviewData.event.groups.forEach((element, index) => {
        //filter and group by all questions
        downQuestions = _.filter(groupAnswers, {
          groupId: element.id,
          // status: 'A',
        });

        //order comment answer
        downQuestions = _.orderBy(downQuestions, ["status"], ["asc"]);

        //Questions count / for domain score
        let questionsCount = _.filter(groupAnswers, {
          groupId: element.id,
          status: "A",
        });

        questionsCount = _.filter(questionsCount, function(o) {
          return o.commentAnswer != "Not Observed";
        });

        let count = 0;
        let percentageScores = []; // Her sorunun yüzdelik skorunu tutacak array

        if (downQuestions.length > 0) {
          downQuestions.forEach((question) => {
            this.editReviewData.questionAnswer.forEach((answer) => {
              if (question.questionId === answer.questionId) {
                if (question.status == "A") {
                  // Skor hesaplama
                  question.itemScore =
                    answer.commentAnswer != "Not Observed"
                      ? Number(answer.commentAnswer)
                      : 0;

                  // Yüzdelik hesaplama
                  if (question.itemScore !== 0) {
                    // "Not Observed" değilse
                    const percentage =
                      (question.itemScore / question.maxScore) * 100;
                    percentageScores.push(percentage);
                  }
                }
              }
            });
          });

          // Domain score'u yüzdelerin ortalaması olarak hesapla
          if (percentageScores.length > 0) {
            const averagePercentage =
              percentageScores.reduce((a, b) => a + b, 0) /
              percentageScores.length;
            downQuestions[0].domainScore = averagePercentage.toFixed(2);
          }
        }

        if (element.questions.length == 0) {
          emptyGroupQuestion.push(index);
        }

        reportArray.push(downQuestions);
      });

      // if (reportArray.length > 0) {
      //   reportArray = _.reject(reportArray, _.isEmpty);
      // }

      if (reportArray.length > 0) {
        reportArray = _.reject(reportArray, _.isEmpty);
      }
      if (emptyGroupQuestion.length > 0) {
        for (var i = emptyGroupQuestion.length - 1; i >= 0; i--)
          this.editReviewData.event.groups.splice(emptyGroupQuestion[i], 1);
      }

      store
        .dispatch("review/createReviewPdf", {
          data: reportArray,
          groups: this.editReviewData.event.groups,
          info: {
            id: this.editReviewData.id,
            eventName: this.editReviewData.event.title,
            surveyDate: this.editReviewData.surveyDate,
            firstName: this.editReviewData.firstName,
            lastName: this.editReviewData.lastName,
            emailAdress: this.editReviewData.emailAdress,
            observer: this.editReviewData.observer,
            generalComment: this.editReviewData.generalComment,
          },
        })
        .then((response) => {
          if (response.status == 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `Quality Review ${this.editReviewData.surveyDate} - ${this
                .editReviewData.firstName +
                " " +
                this.editReviewData.lastName}.pdf`
            );
            document.body.appendChild(link);
            link.click();
            this.download = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Successful",
                text: "✔️ Report is created!",
                icon: "ThumbsUpIcon",
                variant: "success",
              },
            });
            this.formShow = false;
          } else {
            this.formShow = false;
          }
        })
        .catch((error) => {
          this.toastDownloadErrorMessage("Download");
          this.formShow = false;
        });
    },

    downloadNewForm() {
      this.formShow = true;
      this.download = true;

      // Prepare data array (keep original indices; do NOT mutate groups)
      const groups = this.editReviewData?.event?.groups || [];
      const reportArray = groups.map((group) => {
        const questions = group?.questions || [];
        return questions.filter((question) => {
          const isCommentQuestion =
            (question?.questionType ?? question?.status ?? "A") === "B";
          return question?.status === "A" && !isCommentQuestion;
        });
      });

      store
        .dispatch("review/createNewFormPdf", {
          data: reportArray,
          info: {
            id: this.editReviewData.id,
            eventName: this.editReviewData.event.title,
            firstName: this.editReviewData.firstName,
            lastName: this.editReviewData.lastName,
            emailAdress: this.editReviewData.emailAdress,
            observer: this.editReviewData.observer,
            surveyDate: this.editReviewData.surveyDate,
            generalComment: this.editReviewData.generalComment,
            interval_months: this.editReviewData.interval_months ?? null,
          },
          groups,
        })
        .then((response) => {
          if (response.status == 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `${this.editReviewData.event.title} - ${
                this.editReviewData.surveyDate
              } - ${this.editReviewData.firstName +
                " " +
                this.editReviewData.lastName}.pdf`
            );
            document.body.appendChild(link);
            link.click();
            this.download = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Successful",
                text: "✔️ New Form is created!",
                icon: "ThumbsUpIcon",
                variant: "success",
              },
            });
            this.formShow = false;
          } else {
            this.formShow = false;
          }
        })
        .catch((error) => {
          this.toastDownloadErrorMessage("Download");
          this.formShow = false;
        });
    },

    downloadEmptyForm() {
      this.formShow = true;
      this.download = true;

      store
        .dispatch("review/createEmptyFormPdf", {
          info: {
            eventName: this.editReviewData.event.title,
            interval_months: this.editReviewData.interval_months ?? null,
          },
          groups: this.editReviewData.event.groups,
        })
        .then((response) => {
          if (response.status == 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `Empty Form - ${this.editReviewData.event.title}.pdf`
            );
            document.body.appendChild(link);
            link.click();
            this.download = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Successful",
                text: "✔️ Empty Form is created!",
                icon: "ThumbsUpIcon",
                variant: "success",
              },
            });
            this.formShow = false;
          } else {
            this.formShow = false;
          }
        })
        .catch((error) => {
          this.toastDownloadErrorMessage("Download");
          this.formShow = false;
        });
    },

    getReviewData(id) {
      this.formShow = true;
      store
        .dispatch("review/fetchReview", id)
        .then((res) => {
          if (res.status === 200) {
            this.editReviewData = {
              id: res.data.id ? res.data.id : 0,
              firstName: res.data.firstName ? res.data.firstName : "",
              lastName: res.data.lastName ? res.data.lastName : "",
              emailAdress: res.data.emailAdress ? res.data.emailAdress : "",
              observer: res.data.observer ? res.data.observer : "",
              event: res.data.event ? res.data.event : { groups: [] },
              generalComment: res.data.generalComment
                ? res.data.generalComment
                : "",
              questionAnswer: res.data.questionAnswer
                ? _.values(res.data.questionAnswer)
                : [],
              //groups: res.data.event.groups ? res.data.event.groups : [],
              surveyDate: res.data.surveyDate
                ? this.convertDateToDisplay(res.data.surveyDate)
                : null,
              status: res.data.status ? res.data.status : "A",
              person: res.data.fullName ? res.data.fullName : null,
              selectedTask: res.data.task ? res.data.task : null,
              startTime: res.data.start_time
                ? this.formatTime(res.data.start_time)
                : null,
              endTime: res.data.end_time
                ? this.formatTime(res.data.end_time)
                : null,
              workingTime: res.data.working_time ? res.data.working_time : "am",
            };

            // If no task on review but questionnaire has task, inherit from questionnaire
            if (!this.editReviewData.selectedTask && res.data.event?.task) {
              this.editReviewData.selectedTask = res.data.event.task;
            }

            this.selectedPerson = this.editReviewData.person;

            //sort questions by order field to maintain correct sequence
            this.editReviewData.event.groups.forEach((group) => {
              group.questions = _.orderBy(group.questions, ["order"], ["asc"]);
            });
            this.currentUser = this.editReviewData.observer;

            // Fetch summary data after loading review data
            if (this.editReviewData.id) {
              this.fetchSummaryData(this.editReviewData.id);
            }

            // Populate follow-up data directly from the response
            this.pendingFollowUps = res.data.pending_follow_ups || [];
            this.promotedFollowUps = res.data.promoted_follow_ups || [];

            // Store original_review on editReviewData for the banner
            this.$set(this.editReviewData, 'original_review', res.data.original_review || null);
            this.$set(this.editReviewData, 'review_type', res.data.review_type || null);
            this.$set(this.editReviewData, 'interval_months', res.data.interval_months || null);

            // Trigger reactivity
            this.forceRecompute++;

            // Update time configs after loading data
            this.updateTimeConfigs(this.editReviewData.workingTime || "am");

            this.formShow = false;
          }
        })
        .catch((error) => {
          this.toastErrorMessage("Review");
          console.log(error);
          this.formShow = false;
        });
    },
    formSubmitted() {
      this.formShow = true;
      this.$refs.reviewRules.validate().then((success) => {
        if (success) {
          this.editReviewData.questionAnswer.forEach((questionAnswer) => {
            this.editReviewData.event.groups.forEach((group) => {
              group.questions.forEach((question) => {
                if (questionAnswer.questionId == question.id) {
                  questionAnswer.commentAnswer = question.commentAnswer;
                }
              });
            });
          });

          if (this.editReviewData.person) {
            delete this.editReviewData.person;
          }

          // Convert date to backend format (MM-DD-YYYY) before sending
          const reviewDataToSend = { ...this.editReviewData };
          if (reviewDataToSend.surveyDate) {
            reviewDataToSend.surveyDate = this.convertDateToBackend(
              reviewDataToSend.surveyDate
            );
          }

          store
            .dispatch("review/editReview", reviewDataToSend)
            .then((res) => {
              this.toastMessage("Review");
              setTimeout(() => {
                this.formShow = false;
                // router.push({ name: "review-list" });
              }, 100);
            })
            .catch((error) => {
              console.log(error);
              this.formShow = false;
            });
        } else {
          this.formShow = false;
        }
      });
    },
    toastMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Successful",
          text: "✔️ " + val + " Edit Successful",
          icon: "ThumbsUpIcon",
          variant: "success",
        },
      });
    },
    toastCompleteMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Successful",
          text: "✔️ " + val + " Complete Successful",
          icon: "ThumbsUpIcon",
          variant: "success",
        },
      });
    },
    toastErrorMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: "× " + val + " error!",
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    toastDownloadErrorMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: "× " + val + " Data not found!",
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    // Enhanced Preview Methods
    getOrderedQuestions(group) {
      if (!group.questions) {
        return [];
      }
      // Sort questions by order field, fallback to original order
      return [...group.questions].sort((a, b) => {
        if (a.order && b.order) {
          return a.order - b.order;
        }
        return 0;
      });
    },

    isCompulsoryQuestion(question) {
      // A question is compulsory if max score equals passing score
      return (
        question.maxScore &&
        question.passingScore &&
        question.maxScore === question.passingScore
      );
    },

    calculateGroupScore(group) {
      if (!group.questions) return 0;

      let totalScore = 0;
      group.questions.forEach((question) => {
        // Sadece scoring questions (status 'A') için toplam hesapla
        if (question.status === "A") {
          const answer = this.getQuestionAnswerById(question.id);
          if (
            answer !== "No answer" &&
            answer !== "Not Observed" &&
            !isNaN(answer)
          ) {
            totalScore += parseFloat(answer);
          }
        }
      });

      return totalScore.toFixed(0);
    },

    calculateGroupMaxScore(group) {
      if (!group.questions) return 0;

      let maxScore = 0;
      group.questions.forEach((question) => {
        // Sadece scoring questions (status 'A') için max score topla
        if (question.status === "A" && question.maxScore) {
          maxScore += question.maxScore;
        }
      });

      return maxScore;
    },

    getGroupStatus(group) {
      if (!group.questions || group.questions.length === 0) {
        return "No Questions";
      }

      const failedStatus = this.getFailedStatus;

      // Check for compulsory question failures first
      const hasCompulsoryFailure = group.questions.some((question) => {
        if (this.isCompulsoryQuestion(question)) {
          const answer = this.getQuestionAnswerById(question.id);
          if (answer === "No answer" || answer === "Not Observed") {
            return true;
          }
          const score = parseFloat(answer);
          return !isNaN(score) && score < question.passingScore;
        }
        return false;
      });

      if (hasCompulsoryFailure) {
        return failedStatus + "(Compulsory)";
      }

      // Check group score requirement if exists
      if (group.score) {
        const currentGroupScore = parseFloat(this.calculateGroupScore(group));
        if (currentGroupScore < group.score) {
          return  failedStatus + "(Group Score)";
        }
      }

      // Check individual question failures
      const failedQuestions = group.questions.filter((question) => {
        if (question.status === "B") return false; // Comment questions don't fail

        const answer = this.getQuestionAnswerById(question.id);
        if (answer === "No answer" || answer === "Not Observed") {
          return false; // "Not Observed" is not considered a failure unless compulsory
        }

        const score = parseFloat(answer);
        return (
          !isNaN(score) &&
          question.passingScore &&
          score < question.passingScore
        );
      });

      if (failedQuestions.length > 0) {
        return failedStatus;
      }

      return "Passed";
    },

    getGroupStatusVariant(group) {
      const status = this.getGroupStatus(group);
      if (status.includes("Failed")) return "warning";
      if (status === "Passed") return "success";
      return "secondary";
    },

    getQuestionStatus(question, group) {
      if (question.status === "B") {
        return "Comment";
      }
      const failedStatus = this.getFailedStatus;

      const answer = this.getQuestionAnswerById(question.id);

      if (answer === "No answer") {
        return "No Answer";
      }

      if (answer === "Not Observed") {
        if (this.isCompulsoryQuestion(question)) {
          return failedStatus + "(Compulsory)";
        }
        return "Not Observed";
      }

      const score = parseFloat(answer);
      if (isNaN(score)) {
        return "Invalid Score";
      }

      if (question.passingScore && score < question.passingScore) {
        if (this.isCompulsoryQuestion(question)) {
          return failedStatus + "(Compulsory)";
        }
        return failedStatus;
      }

      // Eğer passing score 0 ise "Completed", değilse "Passed"
      if (question.passingScore === 0) {
        return "Completed";
      }

      return "Passed";
    },

    getQuestionStatusVariant(question, group) {
      const failedStatus = this.getFailedStatus;
      const status = this.getQuestionStatus(question, group);
      if (status.includes("Failed")) return "warning";
      if( status.includes(failedStatus)) return "warning";
      if (status === "Passed") return "success";
      if (status === "Completed") return "primary";
      if (status === "Comment") return "info";
      if (status === "Not Observed") return "secondary";
      return "secondary";
    },

    getQuestionRowClass(question, group) {
      const status = this.getQuestionStatus(question, group);
      if (status.includes("Failed")) {
        return "table-danger-row";
      }
      return "";
    },

    getAnswerStyle(question, group) {
      const answer = this.getQuestionAnswerById(question.id);
      const status = this.getQuestionStatus(question, group);
      const failedStatus = this.getFailedStatus;
      // Comment questions - light blue
      if (question.status === "B") {
        return "background-color:#E6F3FF; border-left: 3px solid #17a2b8;";
      }

      // Failed questions - light orange
      if (status.includes("Failed")) {
        return "background-color:#fff3cd; border-left: 3px solid #fd7e14; font-weight: 600;";
      }
      if (status.includes(failedStatus)) {
        return "background-color:#fff3cd; border-left: 3px solid #fd7e14; font-weight: 600;";
      }

      // Not Observed - light yellow
      if (answer === "Not Observed") {
        return "background-color:#fff3cd; border-left: 3px solid #ffc107;";
      }

      // No answer - light gray
      if (answer === "No answer") {
        return "background-color:#f8f9fa; border-left: 3px solid #6c757d;";
      }

      // Passed questions - light green
      if (status === "Passed") {
        return "background-color:#D9FFF7; border-left: 3px solid #28a745; font-weight: 500;";
      }

      // Completed questions - light blue
      if (status === "Completed") {
        return "background-color:#E3F2FD; border-left: 3px solid #007bff; font-weight: 500;";
      }

      return "background-color:#f8f9fa;";
    },

    getQuestionAnswerById(questionId) {
      if (!this.editReviewData || !this.editReviewData.questionAnswer) {
        return "No answer";
      }

      const answer = this.editReviewData.questionAnswer.find(
        (qa) => qa.questionId === questionId
      );

      if (!answer || answer.commentAnswer === null || answer.commentAnswer === undefined || answer.commentAnswer === "") {
        return "No answer";
      }

      return answer.commentAnswer;
    },

    // Original Methods
    takeAQuestionAnswer(ans) {
      this.ans = ans;
    },

    dateFormat(val) {
      return moment(String(val)).format("DD-MM-YYYY HH:mm");
    },

    // Check if the current total score falls within this range
    isCurrentRange(range) {
      // Force reactivity trigger
      this.forceRecompute;

      const currentScore = this.calculatedTotalScore;

      if (range.maxScore === "+") {
        return currentScore >= range.minScore;
      } else {
        return currentScore >= range.minScore && currentScore <= range.maxScore;
      }
    },

    openPromoteModal(fu) {
      this.promotingFu = fu;
      this.promoteForm = {
        reviewDate: null,
        startTime: fu.start_time || null,
        endTime: fu.end_time || null,
        workingTime: fu.working_time || 'am',
      };
      this.showPromoteModal = true;
    },

    promoteSetWorkingTime(type) {
      this.promoteForm.workingTime = type;
      if (type === 'am') {
        this.promoteStartTimeConfig = { ...this.promoteStartTimeConfig, defaultHour: 8 };
        this.promoteEndTimeConfig = { ...this.promoteEndTimeConfig, defaultHour: 9 };
        if (!this.promoteForm.startTime || this.promoteForm.startTime > '12:00') this.promoteForm.startTime = '08:00';
        if (!this.promoteForm.endTime || this.promoteForm.endTime > '12:00') this.promoteForm.endTime = '09:00';
      } else {
        this.promoteStartTimeConfig = { ...this.promoteStartTimeConfig, defaultHour: 13 };
        this.promoteEndTimeConfig = { ...this.promoteEndTimeConfig, defaultHour: 17 };
        if (!this.promoteForm.startTime || this.promoteForm.startTime < '13:00') this.promoteForm.startTime = '13:00';
        if (!this.promoteForm.endTime || this.promoteForm.endTime < '13:00') this.promoteForm.endTime = '17:00';
      }
    },

    confirmPromote() {
      if (!this.promotingFu) return;
      const params = {};
      if (this.promoteForm.reviewDate) {
        const parsed = moment(this.promoteForm.reviewDate, 'DD/MM/YYYY', true);
        params.reviewDate = parsed.isValid() ? parsed.format('YYYY-MM-DD') : this.promoteForm.reviewDate;
      }
      if (this.promoteForm.startTime) params.startTime = this.promoteForm.startTime;
      if (this.promoteForm.endTime) params.endTime = this.promoteForm.endTime;
      if (this.promoteForm.workingTime) params.workingTime = this.promoteForm.workingTime;
      this.showPromoteModal = false;
      this.promoteAndRedirect(this.promotingFu.id, params);
    },

    promoteAndRedirect(pendingId, params) {
      this.promotingId = pendingId;
      store
        .dispatch('review/promoteFollowup', { id: pendingId, params: params || {} })
        .then((response) => {
          const resultId = response.data && (response.data.result_id || response.data.id);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Follow-up started',
              text: 'The follow-up review has been created.',
              icon: 'CheckIcon',
              variant: 'success',
            },
          });
          if (resultId) {
            this.$router.push({ name: 'review-edit', params: { id: resultId } });
          } else {
            this.getReviewData(this.$route.params.id);
          }
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              text: 'Failed to start follow-up review.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => {
          this.promotingId = null;
        });
    },

    // Fetch full summary data with ranges from backend
    fetchSummaryData(surveyId) {
      // Use new endpoint that fetches from summaries table by surveyId
      axiosIns
        .get(`summaryReview/${surveyId}`)
        .then((response) => {
          if (response.data) {
            // Check if response has ranges and explanations at top level (new format)
            if (response.data.ranges && response.data.explanations) {
              this.summaryData = {
                ranges: response.data.ranges,
                explanations: response.data.explanations,
                maxScore: response.data.maxScore,
              };
            } else if (response.data.title) {
              // Check if title contains ranges and explanations (nested format)
              if (
                response.data.title.ranges &&
                response.data.title.explanations
              ) {
                this.summaryData = response.data.title;
              } else {
                // Fallback: just store the explanation in storedExplanation
                this.storedExplanation = response.data.title;
              }
            }

            // Trigger reactivity
            this.forceRecompute++;
          }
        })
        .catch((error) => {
          console.error("Error fetching summary data:", error);
          // If summary not found in summaries table, that's okay - means this review hasn't been customized yet
          if (error.response && error.response.status === 404) {
            console.log(
              "No custom summary found for this review - will use questionnaire defaults"
            );
          }
        });
    },
    // Files Modal Methods
    openFilesModal() {
      this.showFilesModal = true;
      this.loadQuestionnaireFiles();
    },
    async loadQuestionnaireFiles() {
      if (!this.editReviewData.event || !this.editReviewData.event.id) return;

      this.loadingFiles = true;
      try {
        const response = await this.$http.get(
          `questionnaire-files/${this.editReviewData.event.id}`
        );
        this.questionnaireFiles = response.data;
      } catch (error) {
        console.error("Load files error:", error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            text: "Failed to load files",
            variant: "danger",
          },
        });
      } finally {
        this.loadingFiles = false;
      }
    },
    formatFileSize(bytes) {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },
    formatDate(dateString) {
      const date = new Date(dateString);

      // DD/MM/YYYY format
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      // 12-hour format with AM/PM
      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";

      hours = hours % 12;
      hours = hours ? hours : 12; // 0 saati 12 yap
      const formattedHours = String(hours).padStart(2, "0");

      return `${day}/${month}/${year} ${formattedHours}:${minutes} ${ampm}`;
    },
    formatUkDate(value) {
      if (!value) return "";

      const str = String(value).trim();

      // Already in DD/MM/YYYY (common in this app via flatpickr)
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) return str;

      // ISO-like YYYY-MM-DD[...] -> format without timezone shifts
      const isoMatch = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (isoMatch) {
        const [, y, m, d] = isoMatch;
        return `${d}/${m}/${y}`;
      }

      const date = new Date(str);
      if (Number.isNaN(date.getTime())) return str;

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.left-align .nav-tabs .nav-link {
  justify-content: left !important;
}
.animate__animated.animate__fadeIn {
  --animate-delay: 2s;
}

/* V-Select dropdown text truncation */
.vs__dropdown-option {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 100% !important;
}

.vs__selected {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: calc(100% - 20px) !important;
}

/* Fix for v-select dropdown menu items */
.vs__dropdown-menu {
  max-width: 100% !important;
}

.vs__dropdown-option div {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 100% !important;
}

/* Fix for selected option in the input */
#event .vs__selected {
  max-width: calc(100% - 30px) !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

/* Table dropdown fix for z-index and overflow */
.table {
  overflow: visible !important;

  /* Time select styling */
  .vs__dropdown-toggle {
    border: 1px solid #d8d6de;
    border-radius: 0.357rem;
    min-height: 38px;
    padding: 0.571rem 0.857rem;
  }

  .vs__selected {
    font-size: 1rem;
    color: #6e6b7b;
  }

  td,
  th {
    overflow: visible !important;
    position: relative;
  }

  /* Table wrapper should also allow overflow */
  .table-responsive {
    overflow: visible !important;
  }
}

/* V-Select in table cells - fix z-index issues */
.table .vs__dropdown-toggle {
  position: relative;
  z-index: 10;
}

.table .vs__dropdown-menu {
  position: absolute !important;
  z-index: 1000 !important;
  min-width: 200px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid #ddd;
  background: white;
}

/* Ensure table cells containing dropdowns can overflow */
.table td:has(.v-select),
.table th:has(.v-select) {
  overflow: visible !important;
  position: relative;
}

/* Fix for Bootstrap table responsive wrapper */
.table-responsive {
  overflow: visible !important;
}

/* Summary Ranges Styling */
.summary-card {
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.1);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 6px 20px rgba(0, 123, 255, 0.15);
    transform: translateY(-2px);
  }
}

.summary-header {
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(0, 123, 255, 0.1);

  .summary-icon {
    width: 40px;
    height: 40px;
    background: linear-gradient(
      135deg,
      rgba(0, 123, 255, 0.1),
      rgba(0, 123, 255, 0.2)
    );
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .summary-icon-small {
    width: 28px;
    height: 28px;
    background: linear-gradient(
      135deg,
      rgba(0, 123, 255, 0.1),
      rgba(0, 123, 255, 0.2)
    );
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.current-range-card-slim {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border-radius: 8px;
  padding: 1rem 1.5rem;
  color: white;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
  min-height: 80px;
  gap: 2rem;

  .total-score-section {
    flex-shrink: 0;
    min-width: 150px;
    text-align: center;

    .score-label {
      font-size: 0.9rem;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.8);
      margin-bottom: 0.25rem;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .score-value {
      font-size: 2rem;
      font-weight: 700;
      color: white;
      line-height: 1;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }
  }

  .explanation-section {
    padding-left: 2rem;
    border-left: 2px solid rgba(255, 255, 255, 0.3);
    display: flex;
    align-items: center;

    .explanation-text {
      font-size: 1rem;
      line-height: 1.5;
      color: rgba(255, 255, 255, 0.95);
      font-weight: 500;
    }
  }
}

.no-data-state-compact {
  color: #6c757d;

  .feather {
    opacity: 0.5;
  }
}

.current-range-card {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border-radius: 12px;
  padding: 1.5rem;
  color: white;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 100px;
    height: 100px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    transform: translate(30px, -30px);
  }

  .range-header {
    position: relative;
    z-index: 2;
  }

  .range-info {
    .range-score {
      font-size: 1.5rem;
      font-weight: bold;
      color: white;
      margin-bottom: 0.25rem;
    }

    .range-label {
      font-size: 0.85rem;
      color: rgba(255, 255, 255, 0.8);
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  }

  .range-actions {
    .current-badge {
      background: rgba(255, 255, 255, 0.2);
      padding: 0.4rem 0.8rem;
      border-radius: 20px;
      backdrop-filter: blur(10px);

      span {
        font-size: 0.85rem;
      }
    }

    .add-comment-btn {
      background: rgba(255, 255, 255, 0.9);
      border: none;
      color: #007bff;
      font-weight: 600;
      padding: 0.5rem 1rem;
      border-radius: 8px;
      transition: all 0.3s ease;

      &:hover {
        background: white;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
    }
  }

  .explanation-content {
    position: relative;
    z-index: 2;
    margin-top: 1rem;

    .explanation-text {
      font-size: 0.95rem;
      line-height: 1.6;
      color: rgba(255, 255, 255, 0.95);
      background: rgba(255, 255, 255, 0.1);
      padding: 1rem;
      border-radius: 8px;
      backdrop-filter: blur(5px);
    }
  }
}

.no-data-state {
  color: #6c757d;

  .feather {
    opacity: 0.5;
  }
}

.summary-ranges {
  .range-item {
    transition: all 0.3s ease;
    border: 1px solid transparent;

    &.current-range {
      background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
      border-color: #0056b3;
      box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
      transform: translateY(-2px);

      .range-text {
        font-size: 1.1em;
      }
    }

    &.inactive-range {
      background-color: #f8f9fa;
      border-color: #e9ecef;

      &:hover {
        background-color: #e9ecef;
        transform: translateY(-1px);
      }
    }
  }

  .explanation-text {
    display: block;
    margin-top: 0.5rem;
    line-height: 1.4;
  }
}

/* Enhanced Preview Styling */
.group-section {
  border: 1px solid #e3e6f0;
  border-radius: 0.375rem;
  padding: 1.5rem;
  margin-bottom: 2rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow: visible !important; /* Allow dropdowns to overflow */

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease;
  }

  /* Ensure table within group section allows overflow */
  .table-responsive {
    overflow: visible !important;
  }

  .table {
    overflow: visible !important;

    td,
    th {
      overflow: visible !important;
    }
  }
}

.group-status-badges {
  display: flex;
  align-items: center;
  gap: 0.75rem;

  .group-status-badge {
    font-size: 0.875rem;
    font-weight: 600;
    padding: 0.5rem 1rem;
    border-radius: 0.375rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .group-score-info {
    font-weight: 500;
    color: #6c757d;
    background-color: #f8f9fa;
    padding: 0.25rem 0.75rem;
    border-radius: 0.25rem;
    border: 1px solid #dee2e6;
  }
}

.question-status-badge {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  min-width: 80px;
  text-align: center;
}

.compulsory-badge {
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0.25rem 0.5rem;
  background-color: #ffc107 !important;
  color: #212529 !important;
  border: 1px solid #e0a800;
  border-radius: 0.25rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.question-content {
  .question-badges {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
    margin-bottom: 0.25rem;
  }

  .score-info {
    background-color: #e9ecef;
    padding: 0.15rem 0.4rem;
    border-radius: 0.25rem;
    border: 1px solid #ced4da;

    small {
      font-weight: 500;
      color: #495057;
    }
  }
}

.answer-display {
  font-weight: 600;
  font-size: 0.95rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  display: inline-block;
  min-width: 60px;
  text-align: center;
}

.table-danger-row {
  background-color: rgba(220, 53, 69, 0.1) !important;

  &:hover {
    background-color: rgba(220, 53, 69, 0.15) !important;
  }

  td,
  th {
    border-top-color: rgba(220, 53, 69, 0.2) !important;
  }
}

.table-simple {
  th,
  td {
    vertical-align: middle;
    padding: 0.75rem 0.5rem;
  }

  th {
    background-color: #f8f9fa;
    border-bottom: 2px solid #dee2e6;
    font-weight: 600;
    color: #495057;
  }

  tbody tr {
    transition: background-color 0.2s ease;

    &:hover {
      background-color: rgba(0, 123, 255, 0.04);
    }
  }
}

/* Badge Variants */
.badge-success {
  background: #28a745 !important;
  color: white !important;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3);
}

.badge-danger {
  background: #dc3545 !important;
  color: white !important;
  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.3);
}

.badge-warning {
  background: linear-gradient(135deg, #ffc107 0%, #fd7e14 100%) !important;
  color: #212529 !important;
  box-shadow: 0 2px 4px rgba(255, 193, 7, 0.3);
}

.badge-info {
  background: #17a2b8 !important;
  color: white !important;
  box-shadow: 0 2px 4px rgba(23, 162, 184, 0.3);
}

.badge-secondary {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%) !important;
  color: white !important;
  box-shadow: 0 2px 4px rgba(108, 117, 125, 0.3);
}
</style>

<style scoped>
.tab-title {
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.925rem;
}
</style>
